// In PostOperation.js
import axios from "axios";
import baseurl from "../CrudOperations/customURl";

export const forgotPassword = async ({ EmployeeId, Name, NewPassword }) => {
  try {
    const response = await axios.post(`${baseurl}/employee/forgot-password`, {
      EmployeeId,
      Name,
      NewPassword,
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { error: "Something went wrong" };
  }
};
